const subscriptionSize = 29

export {
    subscriptionSize
}